import React, { FC, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { Button, ButtonIntent, ButtonType } from 'app/design-system/components/Button';
import { useTranslation } from 'app/lang';
import { useFreshchat } from 'app/lib/freshchat';

import dictionary from '../SignModal/SignModal.dictionary.json';

import styles from './SigningHelpButton.module.scss';

export const SigningHelpButton: FC = () => {
  const { t } = useTranslation();
  const freshchat = useFreshchat();
  const history = useHistory();

  const helpButtonHandler = useCallback(() => {
    freshchat?.menuToggleHandler();
    history.replace({ search: '' });
  }, []);

  return (
    <Button type={ButtonType.BUTTON}
            intent={ButtonIntent.DEFAULT}
            onClick={helpButtonHandler}
            className={styles.helpButton}
            data-test="registration-helpButton">
      {t(dictionary.helpButtonText)}
    </Button>
  );
};
